import { useState } from "react";
import { IEvent } from "../../../models/events";
import { IPatient } from "../../../models/patient";
import { useDisclosure } from "@mantine/hooks";
import { Button, Group, Text, Dialog, LoadingOverlay, Textarea } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { IconSend } from "@tabler/icons-react";

const SendSMS = ({ event, patients } :{event: IEvent, patients: IPatient[]}) => {
    const [message, setMessage] = useState<string>('');
    const [opened, { toggle, close }] = useDisclosure(false);
    const [loading, setLoading] = useState(false);

    if (patients.length === 0) {
        return <p>No patients to send message too</p>
    }

    const sendSMS = async () => {
        try {
            setLoading(true);
            const result = await fetch(`${import.meta.env.VITE_MAIN_API}/api/v1/send-message/${event.uid}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    message,
                }),
            });
            if (!result.ok) {
                throw new Error('Error sending SMS');
            }
            notifications.show({
                title: 'SMS Sent',
                message: 'SMS has been sent to all patients',
                color: 'blue',
            });
            setLoading(false);
            setMessage('');
            close();
        } catch (error) {
            console.error(error);
            notifications.show({
                title: 'Error sending SMS',
                message: 'There was an error sending the SMS',
                color: 'red',
            });
            setLoading(false);
            close();
        }
    }
    return(
        <div>
            <p>Send SMS to patients ( {patients.length} )</p>
            <div>
                <Textarea
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Enter message here"
                />
            </div>
            <br />
            <Button
             leftSection={<IconSend />}
             onClick={toggle}>Send SMS</Button>
            <Dialog
                opened={opened}
                withCloseButton
                onClose={close}
                size="lg"
                radius="md"
                position={{ top: '40%', left: '40%' }}
            >
                <LoadingOverlay visible={loading} />
                <Text size="sm" mb="xs" fw={500}>
                    Are you sure you want to send a message to all patients?
                </Text>
        
                <Group align="flex-end">
                    <Button onClick={close}>No</Button>
                    <Button color="green" onClick={sendSMS}>
                        Send Message
                    </Button>
                </Group>
            </Dialog>
        </div>
    );
};

export default SendSMS;